export const APP_STORE_URL = "https://apps.apple.com/app/id6749908943";
export const PLAY_STORE_URL =
  "https://play.google.com/store/apps/details?id=com.fluxabee.app";
export const YOUTUBE_URL = "https://www.youtube.com/@FluxaBee";
export const INSTAGRAM_URL = "https://www.instagram.com/fluxabee/";
export const FACEBOOK_URL = "https://www.facebook.com/fluxabee";

/**
 * External profiles that confirm the Fluxabee brand entity, used as
 * Organization `sameAs` in JSON-LD. Append social profiles (Facebook,
 * Instagram, YouTube, LinkedIn) here as they are created.
 */
export const ORGANIZATION_SAME_AS: string[] = [
  PLAY_STORE_URL,
  APP_STORE_URL,
  YOUTUBE_URL,
  INSTAGRAM_URL,
  FACEBOOK_URL,
];
